import { Controller } from "@hotwired/stimulus"

// The marker container announces its own arrival.
//
// Turbo renders a stream ASYNCHRONOUSLY, so the canvas cannot repaint when the
// fetch resolves — at that moment the old markers are often still in the DOM, and
// repainting from them wipes the highlight that was just applied. connect() fires
// exactly when the fresh element has entered the document, which is the only
// moment the canvas can trust.
export default class extends Controller {
  connect() {
    window.dispatchEvent(new CustomEvent("course-review:markers-changed"))
  }
}
